import React, { useEffect } from 'react';
import './BarterKingDrawer.css'; // reuse same styles

export default function PiGuardianDrawer({ open, onClose }) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => e.key === 'Escape' && onClose?.();
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="bkdr-overlay" role="dialog" aria-modal="true" aria-label="About Pi Guardian">
      <div className="bkdr-scrim" onClick={onClose} />
      <div className="bkdr-sheet" tabIndex={-1}>
        <div className="bkdr-handle" />
        <div className="bkdr-header">
          <div className="bkdr-emoji" aria-hidden>🛡️</div>
          <div className="bkdr-title">Pi Guardian</div>
          <button className="bkdr-close" onClick={onClose} aria-label="Close">✕</button>
        </div>

        <div className="bkdr-content">
          <p className="bkdr-lead">
            Pi Guardian is for users who stay active and show up consistently on BarterFi.
          </p>

          <ul className="bkdr-list">
            <li><b>What counts?</b> Being active in the app over the reward period.</li>
            <li><b>Who gets it?</b> The most consistent active users.</li>
            <li><b>What helps?</b> Opening the app often and staying engaged.</li>
            <li><b>How to keep it?</b> Stay active regularly, not just once in a while.</li>
          </ul>

          <div className="bkdr-hint">
            Consistency matters more than one busy day.
          </div>
        </div>
      </div>
    </div>
  );
}
